let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jUl1g")).then(() => parcelRequire('GOcOT'));